let refreshingForUpdate = false;

async function clearDevelopmentWorkers() {
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));

  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.filter((name) => name.startsWith('agrida-')).map((name) => caches.delete(name)));
  }
}

function activateWaitingWorker(registration: ServiceWorkerRegistration) {
  registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
}

export function initializeServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  if (import.meta.env.DEV) {
    void clearDevelopmentWorkers().catch(() => undefined);
    return;
  }

  window.addEventListener('load', () => {
    const scope = __BASE_PATH__ || '/';
    const swUrl = `${scope.endsWith('/') ? scope : `${scope}/`}sw.js`;

    navigator.serviceWorker.register(swUrl, { scope, updateViaCache: 'none' })
      .then(async (registration) => {
        activateWaitingWorker(registration);
        await registration.update();

        registration.addEventListener('updatefound', () => {
          const worker = registration.installing;
          worker?.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              worker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => undefined);
  });

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshingForUpdate) return;
    refreshingForUpdate = true;
    window.location.reload();
  });
}
